module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('navigation'), _vm._v(" "), _c('div', {
    staticClass: "product-detail-page"
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_vm._v("\n        Loading product...\n      ")]) : (_vm.error) ? _c('div', {
    staticClass: "error"
  }, [_vm._v("\n        " + _vm._s(_vm.error) + "\n      ")]) : (_vm.product) ? _c('div', {
    staticClass: "product-detail"
  }, [_c('div', {
    staticClass: "product-images"
  }, [_c('div', {
    staticClass: "main-image"
  }, [(_vm.selectedImage) ? _c('img', {
    attrs: {
      "src": _vm.selectedImage.image_url,
      "alt": _vm.product.name
    }
  }) : _c('div', {
    staticClass: "no-image"
  }, [_vm._v("No Image")])]), _vm._v(" "), (_vm.product.images && _vm.product.images.length > 1) ? _c('div', {
    staticClass: "image-thumbnails"
  }, _vm._l((_vm.product.images), function(image) {
    return _c('div', {
      key: image.id,
      staticClass: "thumbnail",
      class: {
        active: _vm.selectedImage && _vm.selectedImage.id === image.id
      },
      on: {
        "click": function($event) {
          _vm.selectedImage = image
        }
      }
    }, [_c('img', {
      attrs: {
        "src": image.image_url,
        "alt": _vm.product.name
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-info-section"
  }, [_c('h1', {
    staticClass: "product-title"
  }, [_vm._v(_vm._s(_vm.product.name))]), _vm._v(" "), _c('div', {
    staticClass: "product-price-section"
  }, [(_vm.product.is_on_sale) ? _c('div', {
    staticClass: "sale-badge-large"
  }, [_vm._v("\n              SALE - SAVE " + _vm._s(_vm.product.discount_percentage) + "%\n            ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "price-display"
  }, [(_vm.product.is_on_sale) ? _c('span', {
    staticClass: "price-regular"
  }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(_vm.regularPrice)) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "price-current",
    class: {
      'price-sale': _vm.product.is_on_sale
    }
  }, [_vm._v("\n                $" + _vm._s(_vm.formatPrice(_vm.currentPrice)) + "\n              ")])]), _vm._v(" "), (_vm.product.is_on_sale) ? _c('div', {
    staticClass: "sale-message"
  }, [_vm._v("\n              🎉 Limited time offer! Save $" + _vm._s(_vm.formatPrice(_vm.regularPrice - _vm.currentPrice)) + "\n            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "product-description"
  }, [_c('p', [_vm._v(_vm._s(_vm.product.description))])]), _vm._v(" "), (_vm.product.variants && _vm.product.variants.length > 0) ? _c('div', {
    staticClass: "variant-selection"
  }, [(_vm.availableColors.length > 0) ? _c('div', {
    staticClass: "variant-group"
  }, [_c('label', [_vm._v("Color:")]), _vm._v(" "), _c('div', {
    staticClass: "variant-options"
  }, _vm._l((_vm.availableColors), function(color) {
    return _c('button', {
      key: color,
      staticClass: "variant-btn",
      class: {
        active: _vm.selectedColor === color
      },
      on: {
        "click": function($event) {
          _vm.selectedColor = color
        }
      }
    }, [_vm._v("\n                  " + _vm._s(color) + "\n                ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.availableSizes.length > 0) ? _c('div', {
    staticClass: "variant-group"
  }, [_c('label', [_vm._v("Size:")]), _vm._v(" "), _c('div', {
    staticClass: "variant-options"
  }, _vm._l((_vm.availableSizes), function(size) {
    return _c('button', {
      key: size,
      staticClass: "variant-btn",
      class: {
        active: _vm.selectedSize === size
      },
      on: {
        "click": function($event) {
          _vm.selectedSize = size
        }
      }
    }, [_vm._v("\n                  " + _vm._s(size) + "\n                ")])
  }))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "quantity-section"
  }, [_c('label', [_vm._v("Quantity:")]), _vm._v(" "), _c('div', {
    staticClass: "quantity-control"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.quantity <= 1
    },
    on: {
      "click": _vm.decrementQuantity
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quantity),
      expression: "quantity",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "number",
      "min": "1"
    },
    domProps: {
      "value": (_vm.quantity)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quantity = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('button', {
    on: {
      "click": _vm.incrementQuantity
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _c('div', {
    staticClass: "action-buttons"
  }, [_c('button', {
    staticClass: "btn-add-to-cart",
    attrs: {
      "disabled": !_vm.selectedVariant || !_vm.isAuthenticated
    },
    on: {
      "click": _vm.addToCart
    }
  }, [_vm._v("\n              " + _vm._s(_vm.isAuthenticated ? 'Add to Cart' : 'Login to Purchase') + "\n            ")]), _vm._v(" "), (_vm.cartItemCount > 0) ? _c('button', {
    staticClass: "btn-checkout",
    on: {
      "click": function($event) {
        _vm.$router.push('/checkout')
      }
    }
  }, [_vm._v("\n              Go to Checkout\n            ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn-back",
    on: {
      "click": function($event) {
        _vm.$router.push('/shop')
      }
    }
  }, [_vm._v("\n              Back to Shop\n            ")])]), _vm._v(" "), (!_vm.isAuthenticated) ? _c('div', {
    staticClass: "auth-notice"
  }, [_vm._v("\n            Please "), _c('router-link', {
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("login")]), _vm._v(" to add items to your cart.\n          ")], 1) : _vm._e(), _vm._v(" "), (_vm.addedToCart) ? _c('div', {
    staticClass: "success-message"
  }, [_vm._v("\n            Added to cart! "), _c('router-link', {
    attrs: {
      "to": "/cart"
    }
  }, [_vm._v("View Cart")])], 1) : _vm._e()])]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f533098"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ProductDetail.vue
// module id = 290
// module chunks = 1